<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="header bg-gradient-primary pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Registro Civil</h1>
              <p class="text-white mt-0 mb-2">
                Asociar Registros a
                <strong>JATO</strong> o enviar a evaluación de
                <strong>Lista Premium</strong>
              </p>
              <p class="m-0 mb-5 text-warning text-xs">
                Los registros de
                <strong>Lista Premium</strong> sólo podrán ser editados por un administrador.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-sm-12">
          <div class="card card-body">
            <my-spinner :loading="filters.loading" />
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select
                    class="form-control form-control-alternative"
                    v-model="filters.selected.brand"
                  >
                    <option value>Selecciona una marca</option>
                    <option
                      v-for="s in filters.brands"
                      :value="s.value"
                      :key="s.value"
                    >{{s.caption}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select
                    class="form-control form-control-alternative"
                    v-model="filters.selected.year"
                  >
                    <option value="0">Seleccione el año</option>
                    <option v-for="s in filters.years" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <v-select
                    label="caption"
                    :options="filters.models"
                    v-model="filters.selected.model"
                    style="width:100%"
                    placeholder="Selecciona uno o varios modelos"
                    :disabled="loading"
                  >
                    <span slot="no-options">No hay resultados disponibles</span>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row row-asociations" v-if="filters.results.data">
        <my-spinner :loading="loading" />
        <div class="col-sm-4">
          <div class="card shadow card-records">
            <div class="card-header bg-info text-white">Versiones Registro Civil</div>
            <div class="card-body bg-secondary card-records-body">
              <div
                class="card card-stats card-item-rc"
                v-for="(item, index) in filters.results.data.registrocivil"
                :key="item.id+'_rckey'+index"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <h5 class="card-title text-uppercase mb-0">{{ item.modelo_rc }}</h5>
                      <h6
                        class="card-title text-uppercase mb-0 text-info"
                      >{{item.patentes.length}} patente(s)</h6>
                      <span class="text-xs mb-0">
                        <span
                          role="button"
                          class="badge"
                          :class="item.asociado ? item.id_lb > 0 ? (item.estado == 'PENDIENTE' ? 'badge-warning' : 'badge-info') : 'badge-success':''"
                          v-text="getTitleAsociado(item)"
                        ></span>
                      </span>
                    </div>
                    <div class="col-auto">
                      <label
                        v-if="!isPremium(item)"
                        class="btn nav-link text-sm btn-select"
                        :class="{'active': getCheckedItem(filters.selected.items, item.modelo_rc)}"
                      >
                        <input
                          type="checkbox"
                          v-model="filters.selected.items"
                          class="d-none"
                          :value="item.modelo_rc"
                        />
                        <span class="nav-link-icon d-block">
                          <i class="fa fa-check"></i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="card shadow card-cations">
            <div class="card-header text-center">Acciones</div>
            <div class="card-body bg-secondary text-center" v-if="actions.put">
              <div>
                <button
                  :disabled="_disabledAsociar"
                  class="btn btn-success btn--action mb-10"
                  @click="setInfo"
                >
                  <i class="ni ni-check-bold fa-icon"></i> ASOCIAR
                </button>
              </div>
              <div>
                <button
                  v-if="_disabledDesAsociar"
                  class="btn btn-warning btn--action mb-10"
                  @click="deleteInfo()"
                >
                  <i class="ni ni-fat-delete fa-icon"></i> DESASOCIAR
                </button>
              </div>
              <div>
                <button
                  v-b-modal.mdlLbPremium
                  :disabled="_disabledLb"
                  class="btn btn-outline-danger btn--action mb-10"
                  @click="setModelLb(true)"
                >
                  <i class="ni ni-paper-diploma fa-icon"></i> CREAR PREMIUM
                </button>
              </div>
              <div>
                <button
                  v-b-modal.mdlLbPremium
                  v-if="_showEditLb"
                  class="btn btn-outline-info btn--action"
                  @click="setModelLb(false)"
                >
                  <i class="ni ni-paper-diploma fa-icon"></i> EDITAR PREMIUM
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="card shadow card-records">
            <div class="card-header bg-info text-white">Versiones JATO</div>
            <div class="card-body card-records-body bg-secondary">
              <p
                class="text-muted text-sm text-center"
              >Se encontraron {{ filters.results.data.jato.length }} versiones jato</p>
              <div
                class="card card-stats card-item-rc"
                v-for="(item, index) in filters.results.data.jato"
                :key="item.id+'_jatokey'+index "
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-auto">
                      <label
                        class="btn nav-link text-sm btn-select"
                        :class="{'active': item.id_jato == post.id_jato}"
                        @click="setModelJato(item)"
                      >
                        <span class="nav-link-icon d-block">
                          <i class="fa fa-check"></i>
                        </span>
                      </label>
                    </div>
                    <div class="col">
                      <h5
                        class="card-title text-uppercase mb-0"
                      >{{ item.version }} ({{ item.carroceria }})</h5>
                      <span class="text-xs mb-0">
                        {{ item.marca }} {{ item.modelo }}
                        <span class="text-danger">{{item.agno}}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="mdlLbPremium"
      :title="'Lista Premium: ' + _titleLb"
      no-close-on-backdrop
      no-close-on-esc
      @ok="setInfo"
      ok-title="Guardar"
      cancel-title="Cerrar"
      ok-variant="success"
      :ok-disabled="filters.selected.premium"
    >
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Marca</label>
          <input
            type="text"
            class="form-control"
            placeholder="Ingrese la marca"
            v-model="post.marca"
          />
        </div>
        <div class="form-group col-sm-6">
          <label>Modelo</label>
          <input
            type="text"
            class="form-control"
            placeholder="Ingrese el modelo"
            v-model="post.modelo"
          />
        </div>
        <div class="form-group col-sm-12">
          <label>Versión</label>
          <input
            type="text"
            class="form-control"
            placeholder="Ingrese la versión"
            v-model="post.version"
          />
        </div>
        <div class="form-group col-sm-6">
          <label>Combustible</label>
          <select class="form-control form-control-alternative" v-model="post.combustible">
            <option value="0">Seleccione</option>
            <option v-for="s in filters.fuels" :value="s.value" :key="s.value">{{s.caption}}</option>
          </select>
        </div>
        <div class="form-group col-sm-6">
          <label>Puertas</label>
          <select class="form-control form-control-alternative" v-model="post.puertas">
            <option v-for="s in filters.doors" :value="s.value" :key="s.value">{{s.caption}}</option>
          </select>
        </div>
        <div class="form-group col-sm-6">
          <label>Transmisión</label>
          <select class="form-control form-control-alternative" v-model="post.transmision">
            <option v-for="s in filters.transmissions" :value="s.value" :key="s.value">{{s.caption}}</option>
          </select>
        </div>
        <div class="form-group col-sm-6">
          <label>Carroceria</label>
          <select class="form-control form-control-alternative" v-model="post.carroceria">
            <option value>Seleccione</option>
            <option v-for="s in filters.bodytypes" :value="s.value" :key="s.value">{{s.caption}}</option>
          </select>
        </div>
        <div class="form-group col-sm-12">
          <small
            class="form-text text-muted text-danger text-center"
            v-show="filters.selected.premium"
          >{{getMessage()}}</small>
          <small
            class="form-text text-muted text-info text-center"
            v-show="!filters.selected.isNew"
          >{{getMessage()}}</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import RegistroCivilServices from "@/services/registrocivil.services";
import _ from "underscore";
import { post } from "@/views/operaciones/clasificaciones/models/asociacion.model";

export default {
  name: "Clasificaciones",
  data() {
    return {
      actions: Auth.getActions(this.$route.name),
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/clasificaciones"
      },
      filters: {
        fuels: [],
        transmissions: [
          {
            value: "A",
            caption: "Automática"
          },
          {
            value: "M",
            caption: "Manual"
          }
        ],
        doors: [
          {
            value: 0,
            caption: 0
          },
          {
            value: 1,
            caption: 1
          },
          {
            value: 2,
            caption: 2
          },
          {
            value: 3,
            caption: 3
          },
          {
            value: 4,
            caption: 4
          },
          {
            value: 5,
            caption: 5
          }
        ],
        bodytypes: [],
        brands: [],
        models: [],
        years: [],
        results: [],
        selected: {
          fuel: "",
          transmission: "",
          door: "",
          bodytype: "",
          brand: "",
          model: "",
          year: 0,
          items: [],
          premium: true,
          isNew: false
        },
        loading: true
      },
      post: new post(Auth.getUser().id),
      loading: false,
      messages: {
        danger: "¡Advertencia! Existe más de una versión premium seleccionada",
        warning:
          "¡Advertencia! se actualizarán todos los registros asociados a la lista premium"
      }
    };
  },
  computed: {
    _disabledAsociar() {
      return this.post.id_jato == 0 || this.post.patentes.length == 0;
    },
    _disabledDesAsociar() {
      let filterArray = _.filter(
        this.filters.results.data.registrocivil,
        filter =>
          _.contains(this.filters.selected.items, filter.modelo_rc) &&
          (filter.id_jato > 0 || filter.id_lb > 0)
      );
      return (
        this.filters.selected.items.length > 0 &&
        (this.post.id_jato == 0 || this.post.id_lb > 0) &&
        filterArray.length > 0
      );
    },
    _disabledLb() {
      let filterArray = _.filter(
        this.filters.results.data.registrocivil,
        filter =>
          _.contains(this.filters.selected.items, filter.modelo_rc) &&
          filter.id_jato == 0
      );
      return this.filters.selected.items.length == 0
        ? true
        : !(
            (this.post.id_lb == 0 || this.post.id_lb > 0) &&
            this.post.id_jato == 0
          );
    },
    _titleLb() {
      return (
        this.filters.selected.brand +
        " / " +
        _.map(this.filters.selected.items).join(", ") +
        " / " +
        this.filters.selected.year
      );
    },
    _showEditLb() {
      let filterArray = _.filter(
        this.filters.results.data.registrocivil,
        filter =>
          _.contains(this.filters.selected.items, filter.modelo_rc) &&
          filter.id_jato == 0 &&
          filter.id_lb > 0
      );
      return this.filters.selected.items.length == 0
        ? false
        : filterArray.length > 0 && this.post.id_jato == 0;
    }
  },
  watch: {
    "filters.selected.brand": {
      handler(data) {
        this.filters.models = [];
        this.filters.years = [];
        this.filters.selected.model = "";
        this.filters.selected.year = 0;
        this.filters.selected.items = [];
        this.post = new post(Auth.getUser().id);
        if (data.trim().length > 0) {
          this.getYears(data);
        }
      }
    },
    "filters.selected.model": {
      handler(data) {
        this.filters.selected.items = [];
        this.post = new post(Auth.getUser().id);

        if (data) {
          this.getInfo(
            this.filters.selected.brand,
            this.filters.selected.year,
            data.value
          );
        }
      }
    },
    "filters.selected.year": {
      handler(data) {
        this.filters.results = [];
        this.filters.selected.items = [];
        this.filters.selected.model = "";
        this.post = new post(Auth.getUser().id);
        if (data && data > 0) {
          this.getModels(this.filters.selected.brand, data);
        }
      }
    },
    "filters.selected.items": {
      handler(data) {
        if (this.filters.results.data) {
          this.unionPatentes(data, true);
        }
      }
    }
  },
  methods: {
    getFuels() {
      RegistroCivilServices.filters
        .fuels()
        .then(response => {
          this.filters.fuels = _.map(response.data, m => {
            return { caption: m.combustible, value: m.codCombustible };
          });
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getBodyTypes() {
      RegistroCivilServices.filters
        .bodytypes()
        .then(response => {
          this.filters.bodytypes = _.map(response.data, m => {
            return { caption: m.carroceria, value: m.cod_carroceria };
          });
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getBrands() {
      RegistroCivilServices.filters
        .brands()
        .then(response => {
          this.filters.brands = response.data.brands;
          this.filters.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getModels(brand, agno) {
      this.filters.loading = true;
      RegistroCivilServices.filters
        .models(brand, agno)
        .then(response => {
          this.filters.models = response.data.models;
          this.filters.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getYears(brand) {
      this.filters.loading = true;
      RegistroCivilServices.filters
        .years(brand)
        .then(response => {
          this.filters.years = response.data.years;
          this.filters.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getInfo(brand, year, model) {
      this.filters.loading = true;
      RegistroCivilServices.filters
        .getInfo(brand, year, model)
        .then(response => {
          this.filters.results = response.data;
          this.filters.loading = false;
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          this.filters.loading = false;
        });
    },
    getCheckedItem(arr, value) {
      return _.contains(arr, value);
    },
    setInfo(evt) {
      evt.preventDefault();
      sysMsgs
        .getConfirm("Confirmar asociación de registros", "")
        .then(result => {
          if (result.value) {
            this.loading = true;
            RegistroCivilServices.save
              .setInfo(this.post)
              .then(response => {
                this.loading = false;
                this.updateInfo(true);
                sysMsgs.getMessage("Registro actualizado", "success");
              })
              .catch(error => {
                sysMsgs.getResponseMessage(error.response);
                console.log(error.response.data);
                this.loading = false;
              });
          }
        });
    },
    deleteInfo() {
      sysMsgs
        .getConfirm("¿Seguro que quiere eliminar asociación?", "")
        .then(result => {
          if (result.value) {
            this.loading = true;
            RegistroCivilServices.save
              .deleteInfo(this.post)
              .then(response => {
                this.loading = false;
                this.updateInfo(false);
                sysMsgs.getMessage(response.data.customMessage, "warning");
              })
              .catch(error => {
                sysMsgs.getResponseMessage(error.response);
                console.log(error.response.data);
                this.loading = false;
              });
          }
        });
    },
    setModelJato(item) {
      if (item.id_jato != this.post.id_jato) {
        _.extend(this.post, item);
        this.setPatentes();
      } else {
        this.post = new post(Auth.getUser().id);
        this.unionPatentes(this.filters.selected.items, false);
      }
    },
    setModelLb(isnew) {
      this.post.agno = this.filters.selected.year;
      this.post.id_jato = 0;
      this.post.marca = this.filters.selected.brand;

      let clone = _.filter(this.filters.results.data.registrocivil, f =>
        _.contains(this.filters.selected.items, f.modelo_rc)
      );
      let id_lb = [];
      let version = [];
      let modelo = [];

      _.union(
        _.map(
          clone,
          m =>
            (modelo = _.union(
              modelo,
              _,
              m.modelo.trim().length == 0
                ? m.modelo_rc.toLowerCase().split(" ")
                : m.modelo.toLowerCase().split(" ")
            ))
        )
      );

      _.union(
        _.map(
          clone,
          m =>
            (version = _.union(
              version,
              _,
              m.version.trim().length == 0
                ? m.modelo_rc.toLowerCase().split(" ")
                : m.version.toLowerCase().split(" ")
            ))
        )
      );

      this.post.marca = _.union(_.map(clone, m => m.marca)).join(" ");
      this.post.modelo = modelo.join(" ");
      this.post.version = version.join(" ");
      this.post.agno = _.union(_.map(clone, m => m.agno)).join(" ");

      clone = _.filter(clone, f => f.id_lb > 0);

      this.post.combustible =
        _.union(_.map(clone, m => m.combustible)).length > 1 ||
        _.union(_.map(clone, m => m.combustible)).length == 0
          ? 0
          : _.first(_.union(_.map(clone, m => m.combustible)));
      this.post.carroceria =
        _.union(_.map(clone, m => m.carroceria)).length > 1 ||
        _.union(_.map(clone, m => m.carroceria)).length == 0
          ? ""
          : _.first(_.union(_.map(clone, m => m.carroceria)));
      this.post.transmision =
        _.union(_.map(clone, m => m.transmision)).length > 1 ||
        _.union(_.map(clone, m => m.transmision)).length == 0
          ? "M"
          : _.first(_.union(_.map(clone, m => m.transmision)));
      this.post.puertas =
        _.union(_.map(clone, m => m.puertas)).length > 1 ||
        _.union(_.map(clone, m => m.puertas)).length == 0
          ? 0
          : _.first(_.union(_.map(clone, m => m.puertas)));

      this.post.id_lb = parseInt(
        Math.floor(Math.random() * 100 + 1).toString() +
          new Date().valueOf().toString()
      );

      this.post.id_lb = isnew
        ? this.post.id_lb
        : _.union(_.map(clone, m => m.id_lb)).length > 1 ||
          _.union(_.map(clone, m => m.id_lb)).length == 0
        ? this.post.id_lb
        : _.first(_.union(_.map(clone, m => m.id_lb)));
      //this.filters.selected.isNew = _.union(_.map(clone, m => m.id_lb)).length > 1 || _.union(_.map(clone, m => m.id_lb)).length == 0 ? true : false;
      this.filters.selected.premium =
        _.union(_.map(clone, m => m.id_lb)).length > 1;
      this.filters.selected.isNew = isnew;
      if (!isnew) {
        let editPatentes = _.union.apply(_, _.map(clone, m => m.externas));
        this.post.patentes = _.union(this.post.patentes, editPatentes);
      } else {
        this.setPatentes();
      }
    },
    unionPatentes(data, update) {
      if (this.filters.results.data) {
        let filterArray = _.filter(
          this.filters.results.data.registrocivil,
          filter => _.contains(data, filter.modelo_rc)
        );
        let arrayX = [];
        let mapJato = [];
        mapJato = _.union(arrayX, _.map(filterArray, m => m.id_jato));
        let jato =
          update && mapJato.length <= 1
            ? _.find(this.filters.results.data.jato, find =>
                _.contains(mapJato, find.id_jato)
              )
            : null;
        _.extend(this.post, jato ? jato : new post(Auth.getUser().id));
        this.setPatentes();
      }
    },
    updateInfo(update) {
      let filterArray = _.filter(
        this.filters.results.data.registrocivil,
        filter => _.contains(this.filters.selected.items, filter.modelo_rc)
      );
      _.each(filterArray, data => {
        data.id_jato = update ? this.post.id_jato : 0;
        data.id_lb = update ? this.post.id_lb : 0;
        data.combustible = update ? this.post.combustible : 0;
        data.marca = update ? this.post.marca : this.filters.selected.brand;
        data.modelo = update ? this.post.modelo : "";
        data.version = update ? this.post.version : "";
        data.carroceria = update ? this.post.carroceria : "";
        data.transmision = update ? this.post.transmision : "";
        data.puertas = update ? this.post.puertas : 0;
        data.asociado = update;
        data.externas = this.post.patentes;
        _.extend(
          _.findWhere(this.filters.results, { modelo_rc: data.modelo_rc }),
          data
        );
      });

      //this.getInfo(this.filters.selected.brand, this.filters.selected.model, this.filters.selected.year);
    },
    getTitleAsociado(item) {
      return (
        (item.id_jato > 0
          ? "Jato / "
          : item.id_lb > 0
          ? item.estado == "PENDIENTE"
            ? "Por Aprobar / "
            : "Premium / "
          : "No asociado") +
        (item.asociado ? item.modelo + " " + item.version : "")
      );
    },
    isPremium(item) {
      return item.id_lb > 0 && item.estado.toString().trim() == "APROBADO";
    },
    getMessage() {
      return !this.filters.selected.isNew
        ? this.messages.warning
        : this.messages.danger;
    },
    setPatentes() {
      let filterArray = _.filter(
        this.filters.results.data.registrocivil,
        filter => _.contains(this.filters.selected.items, filter.modelo_rc)
      );
      let arrayX = _.union.apply(
        _,
        _.map(_.map(filterArray, a => a.patentes), b =>
          _.map(b, c => c.patente)
        )
      );
      this.post.patentes = arrayX;
    }
  },
  created() {
    this.getFuels();
    this.getBodyTypes();
    this.getBrands();
  }
};
</script>

<style scoped>
.btn-select {
  color: #ddd;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
}
.btn-select.active {
  color: #fff;
  background-color: #2dce89;
  border: 1px solid #2dce89;
}
.loading-overlay {
  left: 0;
  top: 0;
}
</style>
